import { lazy } from 'react';

const HomePage = lazy(() => import('./HomePage'));
const RoomsPage = lazy(() => import('./RoomsPage'));
const ProductsPage = lazy(() => import('./ProductsPage'));
const CheckoutPage = lazy(() => import('./CheckoutPage'));
const SuccessPage = lazy(() => import('./SuccessPage'));
const SplashPage = lazy(() => import('./SplashPage'));
const UnknownPropertyPage = lazy(() => import('./UnknownPropertyPage'));

export default {
  HomePage,
  RoomsPage,
  ProductsPage,
  CheckoutPage,
  SuccessPage,
  SplashPage,
  UnknownPropertyPage,
};
